<template>
  <div class="">
    <Alert type="warning" show-icon>直接添加，将不需要获取用户确认，直接加入项目。</Alert>
    <Form ref="form" :model="model" :label-width="100" :rules="ruleValidate">
      <Form-item prop="role" label="角色">
        <Select v-model="model.role" filterable clearable>
          <Option v-for="(role, key) in roles" :value="key" :key="key" :label="role"></Option>
        </Select>
      </Form-item>
      <Form-item prop="user_id" label="用户">
        <Select v-model="model.user_id" filterable remote :remote-method="getUsers" :loading="loading"
        placeholder="请输入邮箱查询">
          <Option v-for="(user, key) in users" :value="key" :key="key"
          :label="user"></Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSubmit('form')" long>加入研究</Button>
      </Form-item>
    </Form>
  </div>
</template>

<script>
import { AddMember, GetAssistItems, ListUsers } from '@/api/study.team'

export default {
  name: 'plus-mumber',
  data: function () {
    return {
      model: {
        role: '',
        user_id: '',
        name: ''
      },
      loading: false,
      roles: {},
      users: {},
      ruleValidate: {
        role: [{
          required: true,
          message: '角色不能为空',
          trigger: 'change'
        }],
        user_id: [{
          required: true,
          message: '注册邮箱不能为空',
          trigger: 'blur'
        }]
      }
    }
  },
  created: function () {
    this.getItems()
  },
  methods: {
    handleSubmit: function (name) {
      this.postForm()
    },
    postForm: function () {
      this.model.study_id = this.$route.params.id
      AddMember(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        } else {
          this.$emit('refresh')
          this.$Message.success('用户已被直接加入本研究')
        }
      })
    },
    getItems: function () {
      const id = this.$route.params.id
      GetAssistItems(id).then(async res => {
        this.statuses = res.statuses
        this.roles = res.roles
      })
    },
    remoteUsers: function (query) {
      ListUsers({ query: query }).then(async res => {
        this.users = res
      })
    },
    getUsers: function (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.remoteUsers(query)
        }, 200)
      } else {
        this.users = []
      }
    }
  }
}
</script>

<style>
.text-center{
  text-align: center;
}
</style>
